import { render, staticRenderFns } from "./StyleEditor.vue?vue&type=template&id=5ac37a2c&scoped=true&"
import script from "./StyleEditor.vue?vue&type=script&lang=ts&"
export * from "./StyleEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac37a2c",
  null
  
)

export default component.exports